// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2SAbu","header":"MessagesList_header__1R3EP","chat":"MessagesList_chat__2ZHan"};